export default "__VITE_ASSET__DDRCsfyS__"